import { Component, ElementRef, HostListener, Inject, OnInit, QueryList, viewChild, ViewChildren } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
    selector: "tdms-documentation",
    templateUrl: "./documentation.component.html",
    styleUrls: ["./documentation.component.scss"],
    standalone: false
})
export class DocumentationComponent implements OnInit {
  docTabs: string[] = [
    "Visualization Dashboard",
    "Create a Project",
    "Geographic Analysis",
    "Topic Modeling",
    "Sentiment Analysis",
  ];
  selected: string = this.docTabs[0];

 @ViewChildren('tabBtn') tabBtns!: QueryList<ElementRef>;

 @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      this.dialogRef.close();
    }
  }

  ngAfterViewInit() {
    const firstTab = this.tabBtns.first;
    if (firstTab) {
      setTimeout(() => {
        firstTab.nativeElement.focus();
      }, 200);
    }
  }

  constructor(
    public dialogRef: MatDialogRef<DocumentationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { tab: string }
  ) {}

  ngOnInit() {
    if (this.data.tab) {
      this.selected = this.data.tab;
    }
  }
}
